import React from "react";
import "./footer.css";
import { BsLinkedin } from "react-icons/bs";
import { BsGithub } from "react-icons/bs";
import { BsInstagram } from "react-icons/bs";

const Footer = () => {
  return (
    <footer>
      <div className="footer__socials">
        <a href="https://www.linkedin.com/in/souurabh-raghuwanshi-b4ba02146/">
          <BsLinkedin />
        </a>
        <a href="https://github.com/iamraghuwanshi">
          <BsGithub />
        </a>
        <a href="https://www.instagram.com/iamraghuwanshi/">
          <BsInstagram />
        </a>
      </div>

      <div className="footer__copyright">
        <small>&copy; Sourabh Raghuwanshi. All rightts reserved.</small>
      </div>
    </footer>
  );
};

export default Footer;
